import { Close as ResetIcon, Search as SearchIcon } from "@mui/icons-material";
import { Box, IconButton, Stack, TextField } from "@mui/material";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import CustomerSelect from "../../components/customerSelect/CustomerSelect";
import MonthPicker from "../../components/monthPicker/MonthPicker";
import { startOfPreviousMonth } from "../../misc/dateUtils";

interface SearchValue {
  readonly text: string;
  readonly month: Dayjs;
  readonly customerId: string | null;
}

interface Props {
  readonly value: SearchValue;
  readonly fullWidth?: boolean;
  readonly onChange: (value: Partial<SearchValue>) => void;
}

const TextSearchWithMonth: FC<Props> = ({ value, fullWidth, onChange }) => (
  <Stack
    direction="row"
    spacing={2}
    sx={{
      alignItems: "center",
      flexGrow: fullWidth ? 1 : undefined,
    }}
  >
    <SearchIcon />
    <Box
      sx={{
        flexGrow: 3,
      }}
    >
      <TextField fullWidth value={value.text} label="Szukaj" onChange={(e) => onChange({ text: e.target.value })} />
    </Box>
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <CustomerSelect customerId={value.customerId} onChange={(customerId) => onChange({ customerId })} />
    </Box>
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <MonthPicker value={value.month} onChange={(month) => onChange({ month: month ?? startOfPreviousMonth() })} />
    </Box>
    <IconButton color="inherit" onClick={() => onChange({ text: "", month: startOfPreviousMonth(), customerId: null })}>
      <ResetIcon />
    </IconButton>
  </Stack>
);

export default TextSearchWithMonth;
